import type { MapValuePropId } from '@repo/types/analytic-events/maps-analytic-events';

export interface MapValuePropAvailability {
    supportsCompass: boolean;
    supportsLiveLocation: boolean;
    supportsTeleport: boolean;
}

const universalValueProps = ['join_players', 'progress', 'overlay', 'no_ads', 'all_in_one'] as const;

export function getApplicableMapValueProps({
    supportsCompass,
    supportsLiveLocation,
    supportsTeleport,
}: MapValuePropAvailability): MapValuePropId[] {
    const valueProps: MapValuePropId[] = [...universalValueProps];

    if (supportsTeleport) valueProps.push('teleport');
    if (supportsLiveLocation) valueProps.push('live_location', 'fog_of_war');
    if (supportsCompass) valueProps.push('compass');

    return valueProps;
}

export function shuffleMapValueProps(valueProps: readonly MapValuePropId[], random = Math.random): MapValuePropId[] {
    const shuffled = [...valueProps];

    for (let index = shuffled.length - 1; index > 0; index -= 1) {
        const targetIndex = Math.floor(random() * (index + 1));
        const current = shuffled[index];
        const target = shuffled[targetIndex];
        if (!current || !target) continue;
        shuffled[index] = target;
        shuffled[targetIndex] = current;
    }

    return shuffled;
}
